import React from 'react'

import type {
  ProviderProps,
  RegisterContextData,
} from '../helpers/types/context/register.types'

import { registerReducer } from '../redux/reducer/RegisterReducer'
import { registerInitialState } from '../redux/state/RegisterState'

export const RegisterContext = React.createContext<RegisterContextData>(
  {} as RegisterContextData
)

export function RegisterProvider({ children }: ProviderProps) {
  const [state, dispatch] = React.useReducer(
    registerReducer,
    registerInitialState
  )

  const contextValue = React.useMemo(() => {
    return { state, dispatch }
  }, [state, dispatch])

  return (
    <RegisterContext.Provider value={contextValue}>
      {children}
    </RegisterContext.Provider>
  )
}
